// Fast, native-speed admin scroll retention - optimized for performance
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const useFastAdminScroll = (enabled: boolean = true) => {
  const location = useLocation();
  const scrollPositions = useRef<Map<string, number>>(new Map());
  const lastPath = useRef<string>('');
  const isRestoring = useRef<boolean>(false);

  useEffect(() => {
    if (!enabled) return;
    
    const sidebar = document.querySelector('[data-sidebar="true"]') as HTMLElement;
    if (!sidebar) return;

    // Save current scroll position instantly before navigation
    if (lastPath.current && !isRestoring.current) {
      const currentScroll = sidebar.scrollTop;
      if (currentScroll > 0) {
        scrollPositions.current.set(lastPath.current, currentScroll);
      }
    }

    // Restore scroll position for new path
    const savedPosition = scrollPositions.current.get(location.pathname) || 0;
    if (savedPosition > 0 && location.pathname !== lastPath.current) {
      isRestoring.current = true;
      
      // Use direct assignment for instant scroll - no animation, no delays
      sidebar.scrollTop = savedPosition;
      
      // Clear restoration flag immediately after next frame
      requestAnimationFrame(() => {
        isRestoring.current = false;
      });
    }

    lastPath.current = location.pathname;
  }, [location.pathname, enabled]);
};
